import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CrestMark } from "@/components/Logo";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <CrestMark size={48} className="animate-pulse" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
